module.exports = __webpack_public_path__ + "img/element.6e1e911b.png";